import type { AnalyticsProvider } from '~analytics/types/analyticsProvider';
import type { RuntimeConfig } from 'nuxt/schema';

import {
  automaticallyShowInAppMessages,
  changeUser,
  initialize,
  logCustomEvent,
  openSession,
} from '@braze/web-sdk';

export default class BrazeProvider implements AnalyticsProvider {
  serviceName: string;
  subscribedEvents: string[];
  config: RuntimeConfig;

  constructor(
    serviceName: string,
    config: RuntimeConfig,
    subscribedEvents: string[],
  ) {
    this.serviceName = serviceName;
    this.subscribedEvents = subscribedEvents;
    this.config = config;
  }

  init() {
    if (!this.config.public.brazeApiKey) {
      console.warn('Braze Provider initialized without a BrazeApiKey');
    }

    initialize(this.config.public.brazeApiKey, {
      baseUrl: 'sdk.iad-05.braze.com',
      allowUserSuppliedJavascript: true,
      enableLogging: false,
    });

    automaticallyShowInAppMessages();
  }

  track(eventName: string, eventData?: object) {
    logCustomEvent(eventName, eventData);
  }

  identify(guid: string | undefined) {
    if (guid) {
      changeUser(guid);
      openSession();
    }
  }

  reset() {
    // noop atm
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  setUserProperties(properties: Record<string, unknown>) {
    // noop atm
  }

  getSubscribedEvents() {
    return this.subscribedEvents;
  }
}
